import { z } from "zod/v4";

const AuthzCpmsOperatorSchema = z.looseObject({
  operatorId: z.number(),
  logoUrl: z.string().nullable().optional(),
});

const AuthzWorkspaceDomainSchema = z.looseObject({
  cpms: z
    .looseObject({ operators: z.array(AuthzCpmsOperatorSchema).default([]) })
    .optional(),
});

const AuthzWorkspaceSchema = z.object({
  platformWorkspaceId: z.string(),
  name: z.string().optional(),
  credentialUuid: z.string(),
  domain: AuthzWorkspaceDomainSchema.optional(),
});

const AuthzOrganisationSchema = z.object({
  organizationId: z.string(),
  name: z.string().optional(),
  workspaces: z.array(AuthzWorkspaceSchema),
});

const AuthzContextResponseSchema = z.object({
  organisations: z.array(AuthzOrganisationSchema).default([]),
});

type AuthzCpmsOperator = z.infer<typeof AuthzCpmsOperatorSchema>;
type AuthzWorkspace = z.infer<typeof AuthzWorkspaceSchema>;
type AuthzOrganisation = z.infer<typeof AuthzOrganisationSchema>;
type AuthzContextResponse = z.infer<typeof AuthzContextResponseSchema>;

export {
  AuthzContextResponseSchema,
  AuthzCpmsOperatorSchema,
  AuthzOrganisationSchema,
  AuthzWorkspaceSchema,
};
export type {
  AuthzContextResponse,
  AuthzCpmsOperator,
  AuthzOrganisation,
  AuthzWorkspace,
};
